import * as styles from "./EmptyState.css";

import type { ReactNode } from "react";

import { Icon } from "@frontend/components/atoms/Icon";

export type EmptyStateProps = {
  children: ReactNode;
};

export function EmptyState({ children }: EmptyStateProps) {
  return (
    <div className={styles.container}>
      <Icon name="SearchX" size="lg" className={styles.icon} />
      <p className={styles.text}>{children}</p>
    </div>
  );
}
